import React from 'react';

// Tabla de puntos por puesto, una fila por tamaño de mesa (de `min` a `max`). Con puntaje por tabla,
// un tamaño de mesa sin fila se puntuaría con la fórmula en silencio: el backend rechaza guardar
// una tabla incompleta, y acá cada fila que falta se marca en rojo.
//
// El caso de Catan es 1 al que gana y 0 al resto: así los puntos del torneo SON las victorias.
export default function ScoreTableEditor({ value, min, max, onChange, disabled }) {
    const tabla = value || {};
    const tamaños = [];
    for (let k = Number(min) || 2; k <= (Number(max) || 4); k++) tamaños.push(k);

    const setCelda = (k, i, v) => {
        const fila = (tabla[k] || []).slice();
        while (fila.length < k) fila.push('');
        fila[i] = v === '' ? '' : Number(v);
        onChange({ ...tabla, [k]: fila });
    };

    return (
        <div>
            {tamaños.map((k) => {
                const fila = tabla[k] || tabla[String(k)] || [];
                const completa = fila.length >= k && fila.slice(0, k).every((v) => v !== '' && v != null && Number.isFinite(Number(v)));
                return (
                    <div key={k} className="d-flex align-items-center flex-wrap" style={{ gap: 6, marginBottom: 6 }}>
                        <span style={{ width: 88, fontSize: 12.5, color: completa ? '#5A6169' : '#C4183C' }}>
                            Mesa de {k}{completa ? '' : ' (falta)'}
                        </span>
                        {Array.from({ length: k }, (_, i) => (
                            <input key={i} type="number" className="form-control form-control-sm" disabled={disabled}
                                style={{ width: 58 }} aria-label={`Mesa de ${k}, puesto ${i + 1}`}
                                value={fila[i] == null ? '' : fila[i]}
                                placeholder={`${i + 1}º`}
                                onChange={(e) => setCelda(k, i, e.target.value)} />
                        ))}
                    </div>
                );
            })}
        </div>
    );
}
